import React, { useState } from 'react';
import { Meeting } from '../../../../types/meeting';

interface MeetingTranscriptPanelProps {
  meeting: Meeting;
  isGenerating: boolean;
  onUploadTranscript: (text: string) => void;
}

const MAX_TRANSCRIPT_LENGTH = 500_000;

const MeetingTranscriptPanel: React.FC<MeetingTranscriptPanelProps> = ({
  meeting,
  isGenerating,
  onUploadTranscript
}) => {
  const [showPaste, setShowPaste] = useState(false);
  const [pasteText, setPasteText] = useState('');

  const transcript = meeting.transcript_text;
  const pasteTooLong = pasteText.length > MAX_TRANSCRIPT_LENGTH;

  return (
    <div className="meeting-panel meeting-panel-fill">
      <div className="meeting-panel-header">
        <div>
          <h3 className="meeting-panel-title">Transcript</h3>
          {transcript && (
            <p className="meeting-panel-subtitle">
              {transcript.split('\n').filter(Boolean).length} lines
            </p>
          )}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            className="meeting-btn meeting-btn-secondary meeting-btn-sm"
            onClick={() => setShowPaste(!showPaste)}
            disabled={isGenerating}
          >
            Paste Transcript
          </button>
        </div>
      </div>

      {showPaste && (
        <div style={{ marginBottom: 14 }}>
          <textarea
            className="meeting-form-textarea"
            style={{ width: '100%', minHeight: 140 }}
            placeholder={'Paste the real meeting transcript here...\nSpeaker Name: dialogue'}
            value={pasteText}
            onChange={(e) => setPasteText(e.target.value)}
          />
          {pasteTooLong && (
            <p style={{ color: 'var(--danger, #d64545)', fontSize: 13, margin: '6px 0 0 0' }}>
              Transcript is too long ({pasteText.length.toLocaleString()} characters). Maximum is {MAX_TRANSCRIPT_LENGTH.toLocaleString()}.
            </p>
          )}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
            <button
              className="meeting-btn meeting-btn-secondary meeting-btn-sm"
              onClick={() => { setShowPaste(false); setPasteText(''); }}
            >
              Cancel
            </button>
            <button
              className="meeting-btn meeting-btn-primary meeting-btn-sm"
              disabled={!pasteText.trim() || pasteTooLong}
              onClick={() => {
                onUploadTranscript(pasteText.trim());
                setShowPaste(false);
                setPasteText('');
              }}
            >
              Save Transcript
            </button>
          </div>
        </div>
      )}

      {isGenerating ? (
        <div className="meeting-generating">
          <span className="spinner" /> Saving the transcript...
        </div>
      ) : !transcript ? (
        <div className="meeting-empty-hint">
          No transcript yet. A live session captures the transcript automatically; or
          paste a transcript here to capture the discussion manually.
        </div>
      ) : (
        <div className="meeting-text-block">{transcript}</div>
      )}
    </div>
  );
};

export default MeetingTranscriptPanel;
